import { EMPTY_FIELD } from 'constants/emptyField';

import { useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Chip } from 'shared/mui/Chips';
import { Referral } from 'types/embedded/referral';

type Props = {
  label?: string;
  source?: string;
};
export const MerchantReferralsField: React.FC<Props> = ({ source = 'referrals' }) => {
  const record = useRecordContext<{ [key: string]: Referral[] }>();

  const referrals: Referral[] = record?.[source] || [];

  if (!referrals.length) {
    return <>{EMPTY_FIELD}</>;
  }

  return (
    <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      {referrals.map((ref) => (
        <Chip
          color="primary"
          key={ref.refId}
          label={`${ref.refId}: ${ref.name}`}
          sx={{
            '.MuiChip-label': {
              lineHeight: '12px',
            },
          }}
        />
      ))}
    </Box>
  );
};
